import React from 'react';

const YoutubeOutlinedIcon: React.FC = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.667 16.6666H6.33366C3.83366 16.6666 2.16699 14.9999 2.16699 12.4999V7.49992C2.16699 4.99992 3.83366 3.33325 6.33366 3.33325H14.667C17.167 3.33325 18.8337 4.99992 18.8337 7.49992V12.4999C18.8337 14.9999 17.167 16.6666 14.667 16.6666Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.91676L12.0833 9.16676C12.8333 9.66676 12.8333 10.4168 12.0833 10.9168L10 12.1668C9.16667 12.6668 8.5 12.2501 8.5 11.3334V8.83342C8.5 7.75009 9.16667 7.41676 10 7.91676Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default YoutubeOutlinedIcon;
